<template>
  <v-container class="pa-0" fluid>
    <div class="pt-4">
      <v-card outlined>
        <v-card-title class="pt-2">
          <h3>{{ $t('Darbo krūvis') }}</h3></v-card-title
        >
        <v-card-text>
          <el-overlay-loading dashboard :loading="pageloading" />
          <v-row class="pt-1 pb-3">
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                @change="updateBoard()"
                hide-details
                :beforeDates="formData.to"
                label="Nuo"
                v-model="formData.from"
                validateKey="registered_workload_date_from"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                @change="updateBoard()"
                hide-details
                :afterDates="formData.from"
                label="Iki"
                v-model="formData.to"
                validateKey="registered_workload_date_to"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-autocomplete
                @change="updateBoard()"
                :items="formatedTerms"
                enums
                hide-details
                itemvalue="value"
                itemtext="text"
                label="Žingsnis"
                v-model="formData.period"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <!-- <export-btn
                object="registered-workload"
                :id="chartId"
              ></export-btn> -->
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="pt-1 pb-3">
            <v-col cols="12">
              <Bar
                :chart-options="chartOptions"
                :chart-data="chartData"
                :chart-id="chartId"
                :dataset-id-key="datasetIdKey"
                :plugins="plugins"
                :css-classes="cssClasses"
                :styles="styles"
                :width="width"
                :height="height"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import Enums from '@/enums'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const customTitle = {
  id: 'customTitle',
  afterDraw: (chart, args, opts) => {
    const {
      ctx,
      chartArea: { top },
    } = chart

    if (opts.y.display) {
      ctx.fillStyle = opts.y.color || ChartJS.defaults.color
      ctx.fillText(
        opts.y.text,
        opts.y.offsetX || 40,
        top + (opts.y.offsetY * -1 || -15)
      )
    }
  },
}

const customLabels = {
  id: 'customLabels',
  afterDatasetsDraw: (chart, args, opts) => {
    const ctx = chart.ctx
    const datasets = chart.data.datasets

    datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex)
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          const dataPoint = dataset.data[index] || ''
          const x = element.x
          const y = element.y

          ctx.fillStyle = 'black' // Customize label color
          ctx.font = '10px Arial' // Customize font style
          ctx.textAlign = 'center'
          ctx.fillText(dataPoint, x, y - 10) // Display dataPoint value above the column
        })
      }
    })
  },
}

export default {
  name: 'WorkloadForm',
  components: {
    Bar,
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      //
      formData: {},
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return value.toString()
              },
            },
          },
        },
        plugins: {
          tooltip: {
            intersect: false,
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || ''
                if (label) {
                  label += ': '
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y.toString()
                }
                return label
              },
            },
          },
          customTitle: {
            y: {
              display: true,
              text: 'Veiksmų skaičius',
            },
          },
          customLabels: {
            display: true,
          },
        },
      },
      //
      chartId: 'registered-workload-chart',
      datasetIdKey: 'label',
      width: 400,
      height: 200,
      cssClasses: '',
      styles: {},
      plugins: [customTitle, customLabels],
      colors: [
        'rgba(0, 76, 76, 1)',
        'rgba(255, 153, 102, 1)',
        'rgba(178, 216, 216, 1)',
        'rgba(255, 204, 92, 1)',
        'rgba(19, 122, 127, 1)',
        'rgba(153, 153, 153, 1)',
        'rgba(255, 82, 82, 1)',
        'rgba(0, 80, 115, 1)',
        'rgba(255, 186, 186, 1)',
        'rgba(17, 17, 17, 1)',
      ],
    }
  },
  computed: {
    formatedTerms() {
      return Enums.filterStepWorkload
    },
  },
  created() {
    let date1 = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    let date2 = new Date()
    this.$set(this.formData, 'from', date1.toISOString().slice(0, 10))
    this.$set(this.formData, 'to', date2.toISOString().slice(0, 10))
    this.$set(this.formData, 'period', 'day')

    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true

      this.$axios
        .post(`dashboard/workload`, this.formData)
        .then((res) => {
          this.chartData = {
            labels: res.data.labels,
            datasets: [],
          }

          let i = 0
          for (let user of res.data.users) {
            if (user === undefined) {
              continue
            }
            this.addDataset(i++, user, res.data.data[user])
          }

          this.pageloading = false
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
        })
    },
    updateBoard() {
      this.getData()
    },
    addDataset(index, label, data) {
      this.chartData.datasets.push({
        label: label,
        backgroundColor: this.colors[index % 10],
        borderColor: this.colors[index % 10],
        data: data,
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
